import {
  addDataSource,
  dataSource,
  // genericFs,
  // genericDbx,
  genericRemDb,
  genericMem,
  initRemDb as _i,
  typeDirs
} from '../../shared/Services/dataSource'
// import {dbProps} from './db'
// import {resetConnection} from '../dbConnection'

const initMem = function(){
  addDataSource('mem', genericMem)
}

// const initDb = async function(){
//   await resetConnection()
//   addDataSource('db', dbProps)
// }


// const initDbx = function(){
//   addDataSource('dbx', genericDbx)
// }

const initRemDb = function(user,beta){
  _i(user,beta)
  addDataSource('remDb', genericRemDb)
}

const syncPut = async function(model, file){
  // console.log('tryina syncPut, model and file', model, file)
  let dbFile = await dataSource('remDb')[model].put(file)
  // console.log('got file from rem', dbFile)
  await dataSource('db')[model].kill({_id: dbFile._id})
  await dataSource('db')[model].put(dbFile)
  return dbFile
}

export {dataSource, syncPut, initRemDb, initMem, typeDirs}
